import React from 'react';
import { reportError } from '../services/logger.js';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Aktualisiert den State, damit der nächste Render das Fallback-UI zeigt
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Du kannst den Fehler auch an einen Fehlerberichterstattungsdienst protokollieren
    console.error("ErrorBoundary hat einen Fehler gefangen:", error, errorInfo);
    this.setState({ error, errorInfo });
    reportError({
      type: 'js_error',
      message: error?.message || 'Unbekannter Komponentenfehler (ErrorBoundary)',
      source: 'ErrorBoundary',
      stack_trace: error?.stack || '',
      metadata: { componentStack: errorInfo?.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      // Fallback-UI, wenn ein Fehler auftritt
      if (this.props.fallback) {
        return this.props.fallback;
      }
      
      return (
        <div style={{ padding: '2rem', textAlign: 'center', backgroundColor: '#020617', color: '#e2e8f0', minHeight: '100%', borderRadius: '1rem', border: '1px solid #ef4444' }}>
          <h2 style={{ color: '#ef4444', marginBottom: '1rem' }}>Oh je, ein unerwarteter Fehler ist aufgetreten!</h2>
          <p style={{ marginBottom: '2rem' }}>Die Komponente konnte nicht geladen werden.</p>
          <button 
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              if (this.props.onReset) this.props.onReset();
            }}
            style={{ padding: '0.75rem 1.5rem', background: '#38bdf8', color: '#0f172a', border: 'none', borderRadius: '0.5rem', fontWeight: 'bold', cursor: 'pointer' }}
          >
            Erneut versuchen
          </button>
          
          {this.state.error && (
            <details open style={{ marginTop: '2rem', textAlign: 'left', background: 'rgba(0,0,0,0.5)', padding: '1rem', borderRadius: '0.5rem', overflow: 'auto' }}>
              <summary style={{ cursor: 'pointer', color: '#f87171' }}>Fehlerdetails (Debug Info)</summary>
              <pre style={{ marginTop: '1rem', fontSize: '0.8rem', color: '#cbd5e1', whiteSpace: 'pre-wrap' }}>
                {this.state.error.toString()}
                <br />
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children; 
  }
}
